<!-- <boma-progress-spinner *ngIf="!error && !loaded"></boma-progress-spinner> -->

<div *ngIf="error">
  <p>Error loading data. Please try again later.</p>
</div>

<boma-progress-spinner *ngIf="!loaded; else view"></boma-progress-spinner>
<ng-template #view>
  <!-- WOULD BE NICE TO HAVE A RESTOCK BUTTON -->

  <boma-crud-table
    *ngIf="!error && stockBelowMinimum"
    (changePageClicked)="handleChangePageClicked($event)"
    [paginationData]="paginationData"
    [data]="stockBelowMinimum.items"
    [displaySearchBar]="true"
    [headersValue]="'Stock Alert'"
    [requiredPermissions]="['add-stock-alert']"
    [selectableColumns]="columns"
    [allowDelete]="false"
    [loaded]="!loading"
    [displaySearchBar]="false"
  ></boma-crud-table>
</ng-template>
